import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AlertTriangle } from "lucide-react";

export function AmbulanceConflicts({ ambIds, dates, ends, excludeId }) {
  const [conflicts, setConflicts] = useState([]);
  const key = JSON.stringify([ambIds, dates, ends]);

  useEffect(() => {
    if (!ambIds.length) { setConflicts([]); return undefined; }
    const t = setTimeout(() => {
      const valid = dates.map((d, i) => ({ d, e: ends[i] })).filter((p) => p.d);
      const end_times = Object.fromEntries(valid.filter((p) => p.e).map((p) => [p.d, p.e]));
      api.post("/ambulances/conflicts", { ambulance_ids: ambIds, dates: valid.map((p) => p.d), end_times, exclude_id: excludeId || null })
        .then(({ data }) => setConflicts(data)).catch(() => setConflicts([]));
    }, 400);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, excludeId]);

  if (!conflicts.length) return null;
  return (
    <div className="rounded-lg border border-amber-400 bg-amber-50 p-3 text-xs text-amber-900 space-y-1" data-testid="ambulance-conflicts">
      <p className="font-semibold flex items-center gap-1.5"><AlertTriangle className="h-4 w-4" /> Ambulanza già impegnata alla stessa ora</p>
      {conflicts.map((c, i) => (
        <p key={i} data-testid={`ambulance-conflict-${i}`}>{c.ambulance} · «{c.service}» del {c.date}</p>
      ))}
      <p className="text-amber-800">Puoi salvare comunque, ma verifica che non sia un doppio impegno.</p>
    </div>
  );
}
